module.exports = __webpack_public_path__ + "static/g2-100d28b43626c7406187a779dcd531d3.png";